(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nolvana-compression"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('nolvana-compression')) {
 customElements.define('nolvana-compression', class extends HTMLElement {
  connectedCallback() {
   if (this.abort) return;
   this.video = this.querySelector('video'); this.button = this.querySelector('.nv-cp-toggle');
   if (!this.video || !this.button) return;
   this.abort = new AbortController(); const signal = this.abort.signal;
   this.motion = matchMedia('(prefers-reduced-motion: reduce)');
   this.wantsPlay = this.dataset.autoplay === 'true' && !this.motion.matches;
   this.video.muted = true; this.video.controls = false; this.button.hidden = false;
   this.update = () => {
    const playing = !this.video.paused && !this.video.ended;
    this.button.dataset.playing = String(playing);
    this.button.setAttribute('aria-label', playing ? this.dataset.pauseLabel : this.dataset.playLabel);
   };
   this.play = () => { const attempt = this.video.play(); if (attempt) attempt.catch(() => this.update()); };
   this.button.addEventListener('click', () => {
    if (this.video.paused) { this.wantsPlay = true; this.play(); }
    else { this.wantsPlay = false; this.video.pause(); }
   }, {signal});
   this.video.addEventListener('play', this.update, {signal});
   this.video.addEventListener('pause', this.update, {signal});
   this.video.addEventListener('ended', this.update, {signal});
   this.video.addEventListener('error', () => { this.button.hidden = true; this.video.controls = true; }, {signal});
   this.onMotion = () => { if (this.motion.matches) { this.wantsPlay = false; this.video.pause(); } };
   this.motion.addEventListener('change', this.onMotion);
   this.observer = new IntersectionObserver(entries => {
    this.visible = entries[0].isIntersecting;
    if (this.visible && this.wantsPlay && !document.hidden) this.play(); else this.video.pause();
   }, {threshold:0.15});
   this.observer.observe(this.video);
   document.addEventListener('visibilitychange', () => {
    if (document.hidden) this.video.pause(); else if (this.visible && this.wantsPlay) this.play();
   }, {signal});
   this.update();
  }
  disconnectedCallback() {
   this.observer?.disconnect(); this.abort?.abort(); this.abort = null;
   this.motion?.removeEventListener('change', this.onMotion); this.video?.pause();
  }
 });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nolvana-facial-story"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-nv-story]').forEach((root) => {
    root.querySelectorAll('[data-nv-purchase]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const productForm = document.querySelector('product-form, form[action*="/cart/add"]');
        if (!productForm) return;
        event.preventDefault();
        productForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const control = productForm.querySelector('select, input:not([type="hidden"]), button');
        if (control) window.setTimeout(() => control.focus({ preventScroll: true }), 450);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nolvana-product-faq"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('nolvana-faq'))customElements.define('nolvana-faq',class extends HTMLElement{
 connectedCallback(){if(this.abort)return;this.abort=new AbortController();const signal=this.abort.signal;const items=Array.from(this.querySelectorAll('.nf-item'));
  items.forEach(item=>item.addEventListener('toggle',()=>{if(item.open&&this.dataset.singleOpen==='true')items.forEach(other=>{if(other!==item)other.open=false;});},{signal}));
  this.addEventListener('shopify:block:select',event=>{const item=event.target.closest('.nf-item');if(item&&this.contains(item)){if(this.dataset.singleOpen==='true')items.forEach(other=>{if(other!==item)other.open=false;});item.open=true;}},{signal});
 }
 disconnectedCallback(){this.abort?.abort();this.abort=null;}
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nolvana-review-carousel"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('nolvana-reviews')) customElements.define('nolvana-reviews',class extends HTMLElement{
 connectedCallback(){
  if(this.abort)return;
  this.abort=new AbortController();const signal=this.abort.signal;
  this.track=this.querySelector('.nvr-track');this.cards=Array.from(this.track.querySelectorAll('.nvr-card'));this.controls=this.querySelector('.nvr-controls');this.rotation=this.querySelector('[data-nvr-rotation]');this.dots=Array.from(this.querySelectorAll('[data-nvr-dot]'));this.status=this.querySelector('[data-nvr-status]');
  if(!this.cards.length)return;
  this.index=0;this.hovered=false;this.dragging=false;this.inView=false;this.interactingUntil=0;
  this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.editing=Boolean(window.Shopify?.designMode);this.userPaused=this.dataset.autoplay!=='true'||this.motion.matches||this.editing;
  if(this.cards.length>1){for(const [card,position] of [[this.cards[this.cards.length-1],'start'],[this.cards[0],'end']]){const clone=card.cloneNode(true);clone.dataset.nvrClone=position;clone.setAttribute('aria-hidden','true');clone.inert=true;clone.removeAttribute('data-shopify-editor-block');clone.classList.remove('is-active');clone.querySelectorAll('[id]').forEach(el=>el.removeAttribute('id'));position==='start'?this.track.prepend(clone):this.track.append(clone);}}
  this.slides=Array.from(this.track.querySelectorAll('.nvr-card'));this.controls.hidden=this.cards.length<2;this.updateRotation();
  this.querySelector('[data-nvr-prev]').addEventListener('click',()=>this.step(-1,true),{signal});this.querySelector('[data-nvr-next]').addEventListener('click',()=>this.step(1,true),{signal});
  this.dots.forEach((dot,i)=>dot.addEventListener('click',()=>{this.hold();this.go(this.cards[i],true);},{signal}));
  this.rotation?.addEventListener('click',()=>{this.userPaused=!this.userPaused;this.updateRotation();this.schedule();},{signal});
  this.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'){this.hovered=true;this.clearTimer();}},{signal});
  this.addEventListener('pointerleave',()=>{this.hovered=false;this.schedule();},{signal});
  this.addEventListener('focusin',e=>{if(e.target!==this.rotation){this.userPaused=true;this.updateRotation();this.clearTimer();}},{signal});
  this.track.addEventListener('keydown',e=>{if(['ArrowLeft','ArrowRight','Home','End'].includes(e.key)){e.preventDefault();this.hold();if(e.key==='Home'||e.key==='End')this.go(this.cards[e.key==='Home'?0:this.cards.length-1],true);else this.step(e.key==='ArrowRight'?1:-1,true);}},{signal});
  this.track.addEventListener('wheel',()=>this.hold(),{signal,passive:true});
  this.track.addEventListener('pointerdown',e=>{this.hold();this.pointerId=e.pointerId;this.dragging=true;this.startX=e.clientX;this.startScroll=this.track.scrollLeft;if(e.pointerType==='mouse'&&e.button===0){this.mouseDrag=true;this.track.setPointerCapture(e.pointerId);this.track.classList.add('is-dragging');e.preventDefault();}},{signal});
  this.track.addEventListener('pointermove',e=>{if(this.mouseDrag&&this.pointerId===e.pointerId)this.track.scrollLeft=this.startScroll+this.startX-e.clientX;},{signal});
  const release=()=>{if(!this.dragging)return;this.dragging=false;const mouse=this.mouseDrag;this.mouseDrag=false;this.track.classList.remove('is-dragging');if(mouse)this.go(this.nearest(),true);this.hold();};
  this.track.addEventListener('pointerup',release,{signal});this.track.addEventListener('pointercancel',release,{signal});this.track.addEventListener('lostpointercapture',release,{signal});this.track.addEventListener('dragstart',e=>e.preventDefault(),{signal});
  this.track.addEventListener('scroll',()=>{this.sync();clearTimeout(this.settleTimer);this.settleTimer=setTimeout(()=>this.settle(),160);},{signal,passive:true});
  document.addEventListener('visibilitychange',()=>this.schedule(),{signal});
  this.motion.addEventListener('change',()=>{if(this.motion.matches){this.userPaused=true;this.updateRotation();}this.schedule();},{signal});
  this.addEventListener('shopify:block:select',e=>{const card=e.target.closest('.nvr-card');if(card){this.userPaused=true;this.updateRotation();this.go(card,false);}},{signal});
  this.observer=new IntersectionObserver(entries=>{this.inView=entries[0].isIntersecting;this.schedule();},{threshold:.15});this.observer.observe(this);
  this.resize=new ResizeObserver(()=>{cancelAnimationFrame(this.resizeFrame);this.resizeFrame=requestAnimationFrame(()=>this.go(this.cards[this.index],false));});this.resize.observe(this.track);
  this.frame=requestAnimationFrame(()=>{this.go(this.cards[0],false);this.schedule();});
 }
 leftFor(card){return card.offsetLeft-(this.track.clientWidth-card.offsetWidth)/2;}
 nearest(){const center=this.track.getBoundingClientRect().left+this.track.clientWidth/2;return this.slides.reduce((best,card)=>{const rect=card.getBoundingClientRect();const dist=Math.abs(rect.left+rect.width/2-center);return !best||dist<best.dist?{card,dist}:best;},null).card;}
 go(card,animate){if(!card)return;this.track.scrollTo({left:this.leftFor(card),behavior:animate&&!this.motion.matches?'smooth':'instant'});if(!animate)this.sync();}
 sync(){const card=this.nearest();this.index=Number(card.dataset.reviewIndex);this.slides.forEach(el=>el.classList.toggle('is-active',el===card));this.dots.forEach((dot,i)=>{i===this.index?dot.setAttribute('aria-current','true'):dot.removeAttribute('aria-current');});}
 settle(){if(!this.isConnected||this.dragging)return;const card=this.nearest();if(card.dataset.nvrClone)this.go(this.cards[Number(card.dataset.reviewIndex)],false);if(this.announce){this.status.textContent=this.cards[this.index].getAttribute('aria-label');this.announce=false;}this.schedule();}
 step(direction,manual){if(manual)this.hold();const current=this.nearest();const position=this.slides.indexOf(current);const next=this.slides[position+direction];this.announce=manual;if(next)this.go(next,true);else{this.go(this.cards[this.index],false);this.go(this.slides[this.slides.indexOf(this.cards[this.index])+direction],true);}}
 hold(){this.interactingUntil=Date.now()+10000;this.clearTimer();this.schedule();}
 clearTimer(){clearTimeout(this.timer);this.timer=null;}
 schedule(){this.clearTimer();if(!this.isConnected||this.cards.length<2||this.userPaused||this.hovered||this.dragging||!this.inView||document.hidden||this.motion.matches||this.editing)return;const delay=Math.max(Number(this.dataset.interval)*1000,this.interactingUntil-Date.now());this.timer=setTimeout(()=>this.step(1,false),delay);}
 updateRotation(){if(!this.rotation)return;this.rotation.dataset.paused=String(this.userPaused);this.rotation.setAttribute('aria-label',this.userPaused?this.dataset.playLabel:this.dataset.pauseLabel);}
 disconnectedCallback(){this.abort?.abort();this.abort=null;this.clearTimer();clearTimeout(this.settleTimer);cancelAnimationFrame(this.frame);cancelAnimationFrame(this.resizeFrame);this.observer?.disconnect();this.resize?.disconnect();this.querySelectorAll('[data-nvr-clone]').forEach(el=>el.remove());}
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nolvana-transformation"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('nolvana-transformation')) {
 customElements.define('nolvana-transformation', class extends HTMLElement {
  connectedCallback() {
   if (this.abort) return;
   this.abort = new AbortController();
   const button = this.querySelector('[data-nvt-scroll="true"]');
   button?.addEventListener('click', event => {
    const target = document.querySelector('.vtl-ub-vd-widget') || document.querySelector('button.pp-add-to-cart[name="add"]') || document.querySelector('form[action*="/cart/add"]');
    if (!target) return;
    event.preventDefault();
    const focus = target.matches('button') ? target : target.querySelector('[role="radio"],button[name="add"]');
    focus?.focus({preventScroll:true});
    window.scrollTo({top:Math.max(0,target.getBoundingClientRect().top+window.scrollY-100),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
   }, {signal:this.abort.signal});
  }
  disconnectedCallback() { this.abort?.abort(); this.abort = null; }
 });
}


  } catch(e) { console.error(e); }
})();
})();
